import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src={`${process.env.PUBLIC_URL || ''}/logo/karmatara logo.png`}
                alt="Karmatara Logo" 
                className="footer-logo-img"
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
              <div className="footer-logo-text">
                <h3>KARMATARA</h3>
                <p>निर्माण सेवा प्रा. लि.</p>
              </div>
            </div>
            <p className="footer-description">
              Leading construction company in Nepal, committed to delivering exceptional 
              construction services with integrity, quality, and innovation.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <ul className="footer-links">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/gallery">Projects</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Contact Info</h4>
            <ul className="footer-contact">
              <li>
                <span>Mahalaxmi-2, Lalitpur, Nepal</span>
              </li>
              <li>
                <a href="mailto:karmataranirman@gmail.com">karmataranirman@gmail.com</a>
              </li>
              <li>
                <a href="tel:9766544171">9766544171</a>
              </li>
              <li>
                <a href="https://www.youtube.com/@ramkumarthapa1" target="_blank" rel="noopener noreferrer">
                  YouTube Channel
                </a>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-services">
              <li>Building Construction</li>
              <li>Highway & Roads</li>
              <li>Infrastructure</li>
              <li>Energy Projects</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Karmatara Nirman Sewa Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;

